function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2024 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
import { serviceStaffDelRoleApi, serviceStaffListApi, serviceStaffStatusApi } from '@/api/staff';
import serviceCreat from './serviceCreat';
import { handleDeleteTable } from '@/libs/public';
var optionsData = [{
  value: '1',
  label: '开启'
}, {
  value: '0',
  label: '关闭'
}];
export default {
  name: 'Service',
  components: {
    serviceCreat: serviceCreat
  },
  data: function data() {
    return {
      dialogTableVisible: false,
      optionsData: optionsData,
      loading: false,
      tableData: {
        data: [],
        total: 0
      },
      tableFrom: {
        page: 1,
        limit: 20,
        keyword: '',
        status: ''
      },
      keywords: '',
      uid: '',
      select: 'name',
      searchSelectList: [{
        label: '姓名',
        value: 'name'
      }, {
        label: '用户ID',
        value: 'uid'
      }, {
        label: '手机号',
        value: 'phone'
      }],
      editDialogConfig: {
        visible: false,
        isCreate: 0,
        // 0=添加，1=编辑
        data: {}
      }
    };
  },
  mounted: function mounted() {
    this.getList();
  },
  methods: {
    /**重置 */searchReset: function searchReset() {
      this.keywords = '';
      this.$refs.searchForm.resetFields();
      this.getList(1);
    },
    handleSearchList: function handleSearchList(data) {
      this.tableFrom = _objectSpread(_objectSpread({}, this.tableFrom), data);
      this.getList(1);
    },
    // 列表
    getList: function getList(num) {
      var _this = this;
      this.loading = true;
      this.tableFrom.keywords = encodeURIComponent(this.keywords);
      this.tableFrom.page = num ? num : this.tableFrom.page;
      serviceStaffListApi(this.tableFrom).then(function (res) {
        _this.tableData.data = res.list;
        _this.tableData.total = res.total;
        _this.loading = false;
      }).catch(function (res) {
        _this.$message.error(res.message);
        _this.loading = false;
      });
    },
    pageChange: function pageChange(page) {
      this.tableFrom.page = page;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.tableFrom.limit = val;
      this.getList();
    },
    // 添加
    handleAdd: function handleAdd() {
      this.editDialogConfig.isCreate = 0;
      this.editDialogConfig.visible = true;
    },
    // 编辑
    handleEdit: function handleEdit(row) {
      this.editDialogConfig.data = row;
      this.editDialogConfig.isCreate = 1;
      this.editDialogConfig.visible = true;
    },
    //关闭弹出框
    hideEditDialog: function hideEditDialog(type, isCreate) {
      this.editDialogConfig.visible = false;
      if (type === 0) return;
      this.getList();
      isCreate == 0 && this.$message.success('添加成功');
      isCreate == 1 && this.$message.success('编辑成功');
    },
    handleDel: function handleDel(id) {
      var _this2 = this;
      this.$modalSure('该员工删除后，将无法服务工单').then(function () {
        serviceStaffDelRoleApi(id).then(function (res) {
          _this2.$message.success('删除成功');
          handleDeleteTable(_this2.tableData.data.length, _this2.tableFrom);
          _this2.getList();
        });
      });
    },
    // 修改状态
    onchangeIsShow: function onchangeIsShow(row) {
      var _this3 = this;
      serviceStaffStatusApi(row.id).then(function () {
        _this3.$message.success('修改成功');
        _this3.getList();
      }).catch(function () {
        row.status = !row.status;
      });
    }
  }
};